import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "rask-sticky-save-button",
    styleUrls: ["./sticky-save-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: "./sticky-save-button.component.html"
})
export class StickySaveButtonComponent {

}
